<template>
    <v-content>
        <v-layout class="font-weight-bold">
            <v-flex shrink pt-2 pr-4 style="text-align: left;">
                <span style="font-weight: bold;font-size: 16px;">{{name}}</span>
            </v-flex>
            <v-flex class="field-select">
                <v-file-input
                        v-model="model"
                        :value="model"
                        @input="onChange"
                        prepend-icon=""
                        clear-icon
                        :background-color="backgroundColor"
                        :item-color="itemColor"
                        :color="color"
                        :placeholder="placeholder"
                        outlined
                        dense
                ></v-file-input>
            </v-flex>
            <v-flex shrink pl-4 style="text-align: left">
                <v-btn color="#3E7662" dark>
                    <v-icon class="pr-3">cloud_download</v-icon>
                    <span>Upload</span>
                </v-btn>
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    export default {
        name: "FileInputForm",
        props: {
            model: {
                required: false
            },
            name: String,
            placeholder: String,
            backgroundColor: {
                type: String,
                default: '#FBF6F3'
            },
            color: {
                type: String,
                default: '#3E7662'
            },
            itemColor: {
                type: String,
                default: '#3E7662'
            },
        },
        methods: {
            onChange(val) {
                this.$emit("update-data", val);
            }
        }
    }
</script>

<style scoped>

</style>
